var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header-confirmation',{attrs:{"title":"Mientras se procesa tu pago.","subtitle":"Si tienes alguna consulta escríbenos a <a href='mailto:hello@abstracta.academy' target='_blank'>hello@abstracta.academy</a>"}})}
var staticRenderFns = []

export { render, staticRenderFns }